{
    "features-majority-account-no-fees": {
        "breadcrumbs": "No Hidden fees",
        "meta": {
            "title": "No Hidden fees - MAJORITY",
            "description": "No hidden fees! Stop paying tons of money on expensive overdraft fees, minimum balance fees, and more!"
        },
        "hero": {
            "title": "Forget about the overdraft fees",
            "body": "Save up to $35/month* with no overdraft fees!",
            "disclaimer": "*According to Consumer Financial Protection Bureau data",
            "cta": "Get started"
        },
        "overdraft_content_box": {
            "tagline": "Majority Account",
            "title": "The best way to avoid paying overdraft fees",
            "body": "It’s simple. The best way to avoid overdraft fees is to sign up for an account that doesn’t have them. Unlike many traditional banks, we have no overdraft fee. Reason being we don’t think it’s really fair to let you overdraft your account and then charge you for it.",
            "cta": "Get started",
            "canvas": "Save up to $35/month"
        },
        "no_fees_content_box": {
            "tagline": "Majority Account",
            "title": "No more hidden fees",
            "body": "Besides no overdraft fees, there’s also no minimum balance fees! Whether you have $1 or $1,000 in your account, we won’t charge you more. It’s your money after all, so keep as much or as little in your account as you’d like.",
            "cta": "Get started"
        },
        "compare_fees_content_box": {
            "tagline": "Majority Account",
            "title": "Compare fees for yourself",
            "body": "When it comes to hidden fees, MAJORITY has none.",
            "fee_0": "Overdraft fee",
            "fee_1": "Opening deposit",
            "fee_2": "Minimum balance fee",
            "fee_3": "Foreign transaction fee"
        },
        "spend_anywhere_box": {
            "tagline": "Majority Account",
            "title": "Spend anywhere in the world fee-free",
            "body": "Money doesn’t know borders, so why should your card? No matter where you are in the world, you can use your MAJORITY Visa® Debit Card with no foreign transaction fees. Whether you’re using your card abroad or on international online shops, you won’t be charged an extra fee.",
            "cta": "Get started",
            "canvas": "Easy savings!"
        }
    }
}